export class Checkbox {
  private readonly _input: JQuery<HTMLInputElement>;
  private readonly _group: JQuery<HTMLElement>;

  constructor(input: HTMLInputElement) {
    this._input = $(input);
    this._group = this._input.parent();

    this.init();
  }

  private setupEventHandlers() {
    this._input.on('change', (e) => {
      if (this.isChecked()) {
        this.addCheckedOnGroup();
      } else {
        this._group.removeAttr('data-checked');
      }
    });
  }

  private init() {
    this.setupEventHandlers();
  }

  private isChecked() {
    return this._input.prop('checked');
  }

  private addCheckedOnGroup() {
    this._group.attr('data-checked', 'checked');
  }
}
